import type { Reducer } from 'redux';
import {
  UPDATE_STREAM,
  REMOVE_STREAM,
  streamStatus,
  type StreamAction,
  type UpdateStreamAction,
} from '../actions';

export interface Stream {
  count?: number;
  type?: string;
  ws?: WebSocket;
}

export type StreamState = Record<string, Stream>;

const initialState: StreamState = {};

function reconnect(state: StreamState, action: UpdateStreamAction): StreamState {
  if (!action.name) return state;
  const newState: StreamState = { ...state };
  let count = (newState[action.name] && newState[action.name].count) || 0;
  if (action.increment) {
    count += 1;
  }
  newState[action.name] = {
    ...(newState[action.name] || {}),
    ...action,
    count,
  };
  delete newState[action.name].type;
  return newState;
}

const reducer: Reducer<StreamState, StreamAction> = (state = initialState, action) => {
  let newState: StreamState;

  switch (action.type) {
    case UPDATE_STREAM:
      if (!action.name) return state;
      switch (action.status) {
        case streamStatus.RECONNECTING:
          newState = reconnect(state, action);
          break;
        default:
          newState = { ...state };
          newState[action.name] = {
            ...(newState[action.name] || {}),
            ...action,
          };
          delete newState[action.name].type;
          break;
      }
      return newState;
    case REMOVE_STREAM:
      newState = { ...state };
      delete newState[action.name];
      return newState;
    default:
      return state;
  }
};

export default reducer;
